module.exports = __webpack_public_path__ + "img/libros-gracias.3d81f246.jpg";